import Trigger from './modal/trigger';
import Modal from './modal';

export default { Modal, Trigger };
